var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClose3 = function SvgClose3(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 5.3415L14.6587 4.1665L10.0003 8.82484L5.34199 4.1665L4.16699 5.3415L8.82533 9.99984L4.16699 14.6582L5.34199 15.8332L10.0003 11.1748L14.6587 15.8332L15.8337 14.6582L11.1753 9.99984L15.8337 5.3415Z",
    fill: "#3F3F3E"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClose3);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjgzMzcgNS4zNDE1TDE0LjY1ODcgNC4xNjY1TDEwLjAwMDMgOC44MjQ4NEw1LjM0MTk5IDQuMTY2NUw0LjE2Njk5IDUuMzQxNUw4LjgyNTMzIDkuOTk5ODRMNC4xNjY5OSAxNC42NTgyTDUuMzQxOTkgMTUuODMzMkwxMC4wMDAzIDExLjE3NDhMMTQuNjU4NyAxNS44MzMyTDE1LjgzMzcgMTQuNjU4MkwxMS4xNzUzIDkuOTk5ODRMMTUuODMzNyA1LjM0MTVaIiBmaWxsPSIjM0YzRjNFIi8+Cjwvc3ZnPgo=";